import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// import { CUSTOM_ICONS } from '@/plugins/fontAwesome'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi'
  }
}

export default new Vuetify(opts)
